'use client'

import { SWRConfig } from 'swr'
import { ConfirmProvider, Toaster } from '@streep/ui'
import { OfflineProvider } from '@/lib/offline/provider'
import { isSessionExpired } from '@/lib/session-expired'
import { SessionExpiredNotice } from './layout/session-expired-notice'

/**
 * Globale SWR-config voor client-side fetches (o.a. de topbar-badges):
 * - revalidateOnFocus uit → geen extra round-trip bij elke tab-focus (matcht het
 *   eerdere setInterval-gedrag).
 * - dedupingInterval → identieke requests binnen het venster worden gecoalesceerd
 *   (één poll i.p.v. per component), wat browser↔api-round-trips bespaart.
 * Staleness is begrensd tot het poll-interval per badge, net als voorheen.
 */
export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <SWRConfig
      value={{
        revalidateOnFocus: false,
        dedupingInterval: 5_000,
        // FO-374 C - verlopen sessie -> SWR pauzeert alle revalidatie (badge-polls),
        // zodat een open tab niet blijft 401/403'en. SessionExpiredNotice neemt over.
        isPaused: isSessionExpired,
      }}
    >
      <ConfirmProvider>
        {/* FO-307-A1 - offline-wachtrij + sync-status app-breed beschikbaar. */}
        <OfflineProvider>{children}</OfflineProvider>
        <SessionExpiredNotice />
        <Toaster viewportClassName="top-[calc(4.5rem+env(safe-area-inset-top))] sm:top-auto" />
      </ConfirmProvider>
    </SWRConfig>
  )
}
